import { FC } from 'react';
import { EditorProvider } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import { MenuBar } from './MenuBar';

const extensions = [
  StarterKit.configure({
    bulletList: {
      keepMarks: true,
      keepAttributes: true,
    },
    orderedList: {
      keepMarks: true,
      keepAttributes: true,
    },
  }),
  Underline,
];

interface RichTextEditorMiniProps {
  readOnly?: boolean;
  handleChange: (value: string) => void;
}

export const RichTextEditorMini: FC<RichTextEditorMiniProps> = ({
  readOnly = false,
  handleChange,
}) => {
  return (
    <EditorProvider
      slotBefore={readOnly ? null : <MenuBar isMini={true} />}
      extensions={extensions}
      editable={!readOnly}
      onUpdate={({ editor }) => {
        handleChange(editor.getHTML());
      }}
    />
  );
};
